import React, { Component } from 'react';
import { Spin, Table, Button, Icon, InputNumber, Modal } from 'antd';
import { sanitizerTexto } from '../../util/utilerias';
import { openNotification } from '../../util/notificaciones';
import InventarioRequest from '../../services/Inventario';
const { confirm } = Modal;

/**
 * Evento para cancelar el scroll en input number
 */
document.addEventListener("wheel", function (event) {
    if (document.activeElement.type === "number") {
        document.activeElement.blur();
    }
});

/**
 * Clase para ver el detalle de un inventario
 */
export default class VistaInventario extends Component {
    state = {
        arrArticulosInventario: [],
        filterText: "",
        cargando: false,
        arrDrives: [],
        driveSelected: null,
        scroll: { x: '100%', y: 500 },
        bloquearBotones: false,
        paginacion: {},
        filtros: {
            filtro: undefined,
            page: undefined
        }
    }

    /**
     * Comportamiento del modal cada vez que se despliega.
     * Se aplica al editar o visualizar datos
     * @param: prevProps. propiedades que tenia el componente antes de ser
     * desplegado
     * @return: nada.
     */
    componentDidUpdate = (prevProps) => {
        if(this.props.visible){
            let state = { ...this.state }
            if (this.props.inventario !== prevProps.inventario) {
                if (this.props.inventario) {
                    this.setState({ cargando: true }, () => {
                        InventarioRequest.ListarDetalleInventarioRpt(this.props.inventario?.id).then(response => {
                            state.cargando = false;
                            state.arrArticulosInventario = response.data
                            if (this.props.inventario?.es_editado && this.props.type === 'editar') {
                                openNotification(
                                    'El inventario actual ya fue editado una vez, por lo tanto, no se podrá editar de nuevo.',
                                    'Aviso'
                                )
                                state.bloquearBotones = true;
                            }
                            this.setState(state)
                        }).catch(err => {
                            this.setState({ cargando: false })
                            openNotification(
                                err?.response?.cuerpo,
                                err?.response?.titulo ?? 'Error'
                            )
                        })
                    })
                }
            }
        }
    }

    handlePaginaChange = (paginaSiguiente) => {
        let state = { ...this.state };
        for (var key in state.filtros) {
            if (state.filtros[key] === null || state.filtros[key] === undefined) {
                delete state.filtros[key];
            }
        }

        state.paginaSiguiente = paginaSiguiente
        state.filtros.page = paginaSiguiente
        state.cargando = true
        this.setState({ cargando: true }, () => {
            InventarioRequest.ListarDetalleInventarioPT(this.props.inventario?.id,paginaSiguiente)
                .then(response => {
                    state.cargando = false;
                    state.arrArticulosInventario = response.data
                    if (this.props.inventario?.es_editado && this.props.type === 'editar') {
                        openNotification(
                            'El inventario actual ya fue editado una vez, por lo tanto, no se podrá editar de nuevo.',
                            'Aviso'
                        )
                        state.bloquearBotones = true;
                    }
                    this.setState(state)
                })
                .catch(err => {
                    this.setState({ cargando: false })
                    openNotification(
                        err?.response?.cuerpo,
                        err?.response?.titulo ?? 'Error'
                    )
                })
        })
    }

    financial(x) {
        if(x === null)
            return "";
        return Number.parseFloat(x).toFixed(2);
    }


    render() {
        const columnasArticulos = [
            {
                title: "Código",
                dataIndex: "articulo.codigo",
                key: "articulo.codigo",
                width: 10
            },
            {
                title: "Descripción",
                dataIndex: "articulo.descripcion",
                key: "articulo.descripcion",
                width: 40
            },
            {
                title: "Unidad de almacenamiento",
                dataIndex: "articulo.unidad",
                key: "articulo.unidad",
                width: 15
            },
            {
                title: "Conteo Bodega",
                dataIndex: "conteoBodega",
                key: "conteoBodega",
                width: 20,
                render: (_, record) => (
                    <div style = {{textAlign: "right", marginRight: "50px"}}>
                        <span>{this.financial(record.conteoBodega)}</span>
                    </div>
                )
            },
            {
                title: "Conteo Cocina",
                dataIndex: "conteoCocina",
                key: "conteoCocina",
                width: 20,
                render: (_, record) => (
                    <div style = {{textAlign: "right", marginRight: "50px"}}>
                        <span>{this.financial(record.conteoCocina)}</span>
                    </div>
                )
            },
            {
                title: "Conteo",
                dataIndex: "conteo",
                key: "conteo",
                width: 20,
                render: (_, record) => (
                    <div style = {{textAlign: "right", marginRight: "50px"}}>
                        <span>{this.financial(record.conteo)}</span>
                    </div>
                )
            }
        ]

        return (
            <div>
                <Modal
                    title={this.props.type === 'detalle' ? 'Ver detalle de inventario' : this.props.type === 'editar' ? 'Editar inventario' : ''}
                    onCancel={() => this.props.esconderModal(false)}
                    visible={this.props.visible}
                    width={"95%"}
                    maskClosable={false}
                    confirmLoading={true}
                    centered={true}
                    footer={
                        [
                            <Button
                                id="boton-regresar-editar-inventario-form"
                                className="btnCancelar"
                                key="back"
                                onClick={() => this.props.esconderModal(false)}
                            > Regresar </Button>
                        ]
                    }
                >
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={(_, index) => index}
                            columns={columnasArticulos}
                            dataSource={this.state.arrArticulosInventario}
                            pagination={false}
                            scroll={this.state.scroll}
                        />
                    </Spin>
                </Modal>
            </div>
        )
    }

}